var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"title-text",domProps:{"innerHTML":_vm._s(_vm.text)}}),(_vm.subtitle)?_c('div',{staticClass:"title-subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }